import Vue from 'vue';

let uuid = localStorage.getItem('log_uuid');
let documentReferrer = sessionStorage.getItem('first_visited_referrer');
if (!uuid) {
  uuid = getUuid();
  localStorage.setItem('log_uuid', uuid);
}
if (!documentReferrer) {
  if (document.referrer) {
    documentReferrer = decodeURIComponent(document.referrer);
  } else {
    documentReferrer = 'none';
  }
  sessionStorage.setItem('first_visited_referrer', documentReferrer);
}

function getUuid() {
  const S4 = () => {
    return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
  }
  return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
}

export function handleLog({ apiUrl, operateName, otherParams = undefined }, source = '类案') {
  const [fromPath, fromQuery] = window.location.href.split('#')[1].split('?');

  return Vue.prototype.httpPost('/admin/page/collection', {
    uuid,
    fromPath,
    fromQuery,
    from: { path: documentReferrer, query: {} },
    toPath: '',
    method: 'POST',
    interfaceName: apiUrl,
    operateName,
    source,
    ...(otherParams || {})
  });
}

export function routerLog(params) {
  return Vue.prototype.httpPost('/admin/page/collection', {
    ...params,
    uuid,
    method: 'POST',
    source: '路由跳转law-web'
  });
}

export function crashLog({ to, from , timestamp }) {
  return Vue.prototype.httpPost('/admin/page/collection', {
    uuid,
    to: { path: to.path, query: to.query },
    from: from ? { path: from.path, query: from.query } : {},
    method: 'POST',
    operateName: `页面可能崩溃了，页面打开时间：${timestamp}，发生时间：${Date.now()}`,
    source: '页面崩溃law-web'
  });
}



// WEBPACK FOOTER //
// ./src/service/logger.js